export const STATISTICS_REQUEST = 'STATISTICS_REQUEST'
export const STATISTICS_ERROR = 'STATISTICS_ERROR'
export const STATISTICS_LIST = 'STATISTICS_LIST'
export const STATISTICS_LIST_SUCCESS = 'STATISTICS_LIST_SUCCESS'
